<template>
  <div>
    <!-- <v-snackbar v-model="snackbar" :timeout="timeout" right>
      お問い合わせ内容を送信しました
    </v-snackbar>
    <div class="mt-5">
      <div style="text-align: center;">
        <div class="mt-10" style="margin:auto;max-width:500px">
          どうしてもこのお問い合わせフォームを無料で運用できないようなので、<br>
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdNDBn8wPlcEqLKHj1iTt-CJYeetLlYKphUaCw0zYzCdyvhVg/viewform" target="_blank">Googleのメールフォーム</a>もしくは
          <a href="" target="_blank">今までのメールフォーム</a>に遷移する形にしようと思います。<br><br>
          <v-form ref="form" v-model="valid" v-if="!comform">
            <v-text-field
              v-model="contactForm.name"
              :rules="[rules.required]"
              type="text"
              label="お名前"
              color="success"
              placeholder=" "
              name="name"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="contactForm.email"
              :rules="[rules.required]"
              type="text"
              label="メールアドレス"
              color="success"
              placeholder=" "
              name="email"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="contactForm.phoneNumber"
              type="text"
              label="電話番号"
              color="success"
              placeholder=" "
              name="phoneNumber"
              outlined
              dense
            ></v-text-field>
            <v-textarea
              v-model="contactForm.contents"
              :rules="[rules.required]"
              label="内容"
              color="success"
              placeholder=" "
              name="contents"
              outlined
              dense
            ></v-textarea>

            <div class="my-2">
              <v-btn
                v-if="!comform"
                @click="comform = true"
                depressed
                color="green lighten-2"
                :disabled="!valid"
                >確認</v-btn
              >
            </div>
          </v-form>
          <div v-if="comform">
            <v-row>
              <v-col cols="12" class="comform-text"
                >以下の内容で送信します。</v-col
              >
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="comform-label">お名前</v-col>
              <v-col cols="12" sm="8" class="comform-val">{{
                contactForm.name
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="comform-label"
                >メールアドレス</v-col
              >
              <v-col cols="12" sm="8" class="comform-val">{{
                contactForm.email
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="comform-label">電話番号</v-col>
              <v-col cols="12" sm="8" class="comform-val">{{
                contactForm.phoneNumber
              }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="comform-label">内容</v-col>
              <v-col cols="12" sm="8" class="comform-val">{{
                contactForm.contents
              }}</v-col>
            </v-row>
            <div class="my-2">
              <v-btn
                @click="sendMail()"
                depressed
                color="green lighten-2"
                class="ma-1"
                :disabled="loading"
              >
                <v-progress-circular
                  v-show="loading"
                  :width="3"
                  color="green"
                  indeterminate
                ></v-progress-circular
                >送信</v-btn
              >
              <v-btn @click="comform = false" depressed class="ma-1"
                >キャンセル</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
// import firebase from "firebase";
import sendGrid from "@/js/sendGrid";
export default {
  name: "Mail",
  data: () => ({
    contactForm: {
      name: "",
      email: "",
      phoneNumber: "",
      contents: "",
    },
    rules: {
      required: (value) => !!value || "必須入力です",
      min: (v) => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match",
    },
    valid: true,
    snackbar: false,
    timeout: 2000,
    comform: false,
    loading: false,
  }),
  created() {
    window.location.href = "http://form1.fc2.com/form/?id=745256"
  },
  computed: {
    conformText: function() {
      return (
        "お名前：　" +
        this.contactForm.name +
        "<br>" +
        "メールアドレス：　" +
        this.contactForm.email +
        "<br>" +
        "電話番号：　" +
        this.contactForm.phoneNumber +
        "<br>" +
        "内容：　" +
        this.contactForm.contents.replace(/\r?\n/g, "<br>") +
        "<br>"
      );
    },
  },
  methods: {
    sendMail: async function() {
      if (this.loading) {
        return;
      }
      const payload = {
        subject: "点字サークル「杉」HPからのお問い合わせ",
        text: this.conformText,
        html: this.conformText,
      };
      this.loading = true;
      const res = await sendGrid(payload);
      this.loading = false;
      if (res.data) {
        this.snackbar = true;
        this.contactForm = {
          name: "",
          email: "",
          phoneNumber: "",
          contents: "",
        };
        this.comform = false;
      }
    },
    formReset: function() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped>
div >>> label,
div >>> input,
div >>> textarea {
  font-size: 14px;
}
div >>> .v-input__slot {
  margin-bottom: 4px;
}
div >>> .v-messages__message {
  font-size: 10px;
}
div >>> .v-input {
  margin-bottom: 8px;
}
div >>> .v-text-field input {
  padding: 2px;
}
.comform-val {
  text-align: left;
  font-size: 0.8rem;
  white-space: pre-wrap;
}
.comform-label {
  text-align: left;
  font-weight: bold;
  font-size: 0.8rem;
}
.comform-text {
  text-align: left;
}
</style>
